// Extra JP fee lines on orders (orders.extraJpFees JSON), e.g. Mercari anshin appraisal.
// Mirrors backend utils/priceCalculator/extraJpFees.js: money reads ONLY amountThb —
// a flat THB sum fixed at add-time (never multiplied by qty, never rate-converted).

export const getExtraJpFeesTotalThb = (order) => {
  const fees = order?.extraJpFees;
  if (!Array.isArray(fees) || fees.length === 0) return 0;
  return fees.reduce((sum, fee) => sum + (Number(fee?.amountThb) || 0), 0);
};

export const getUnpaidExtraJpFeesThb = (order) => {
  if (order?.extraJpFeesPaid === true) return 0;
  return getExtraJpFeesTotalThb(order);
};
